// extracted by mini-css-extract-plugin
export default {"oranum":"oranum--P8B0jKFoVSGsfX8","landingPage":"landingPage--cikxJuSqBCVCXv0"};